export default "__VITE_ASSET__DUQvG2li__"